import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PaymentRequestService {
  constructor(private http: HttpClientService) {}

  public getToReconcilePaymentRequests({
    page_number,
    page_size,
    start_date,
    end_date,
    payment_method = undefined,
    order_by = undefined,
    order_dir = undefined,
  }) {
    const options = {
      params: {
        page_number,
        page_size,
        start_date,
        end_date,
        payment_method,
        order_by,
        order_dir,
      },
    };
    return this.http
      .get("/api/payment_requests/to_reconcile", options)
      .pipe(tap((_) => console.log("PaymentRequestService.getToReconcilePaymentRequests: Ok.")));
  }

  public rejectPaymentRequest(id, { cancel_reason = "" }, same_payment = false) {
    const options = {
      cancel_reason,
      same_payment,
    };
    return this.http
      .put(`/api/payment_requests/${id}/reject_reconciled`, options)
      .pipe(tap((_) => console.log("PaymentRequestService.rejectPaymentRequest: Ok.")));
  }

  public createPaymentRequest(body: {
    payment_request: {
      lead: number;
      vin: string;
      payment_method: string;
      bank: string;
      amount: string;
      realized_at: string;
      email: string;
    };
  }): Observable<any> {
    return this.http
      .post("/api/payment_requests", body)
      .pipe(tap((_) => console.log("PaymentRequestService.createPaymentRequest: Ok.")));
  }
}
